<template>
  <section>
    <div class="searchBar">
      <div class="box-ui-check searchbar-content">
        <div class="title">
          <span>검색기준</span> :
        </div>
        <input type="text" class="mr-5" placeholder="회사 아이디" v-model="reqData.siteId" />
        <input type="text" placeholder="회원 아이디" v-model="reqData.memId" />
      </div>
      <div class="box-ui-check searchbar-content mr-5">
        <div class="title">
          <span>날짜</span> :
        </div>
        <date-selector :class="'searchbar-content'" @setStartDate="setStartDate" @setEndDate="setEndDate" :startDefault="startDefault" :endDefault="endDefault" :configs="dateConfigs" />
      </div>
      <button class="btn-search" type="button" @click="pageSeach">
        검색
      </button>
    </div>
    <div class="main-contents-wrapper">
      <article class="total-info-container fx-col-sbw">
        <div class="total-info-wrap">
          <div class="total-info-item">
            <img :src="require('@/assets/img/searchicon.png')" />
            검색
            <span>검색결과</span>
          </div>
          <div class="total-info-item">
            <span class="title">{{ $t(`totalInfo.tatal_list_count`) }}</span> : <span class="value">{{ pageInfo.tatal_list_count }}</span>
          </div>
          <div class="total-info-item">
            <span class="title">{{ $t(`totalInfo.page`) }}</span> : <span class="value">{{ pageInfo.page }}</span>
          </div>
          <div class="total-info-item">
            <span class="title">{{ $t(`totalInfo.tatal_page_count`) }}</span> : <span class="value">{{ pageInfo.tatal_page_count }}</span>
          </div>
        </div>
        <div class="total-info-wrap"></div>
      </article>
      <div class="table-wrapper">
        <table class="mainTable">
          <table-head :headInfo="headInfo" />
          <template v-if="this.tableData.length !== 0">
            <tbody>
              <tr class="row-parent" v-for="(item, index) in tableData" :key="index">
                <td v-if="item.belongCnt!==0">
                  <button :style="{ left: item.depth * 20 + 'px' }" style="display:flex;" type="button" class="btn-childOpen" @click="setChildTree(item, index)">
                    <i class="fas" :class="item.toggle ? 'fa-minus' : 'fa-plus'"></i>
                  </button>
                </td>
                <td v-if="item.belongCnt===0">
                  <button :style="{ left: item.depth * 20 + 'px' }" type="button" class="btn-childOpen">
                    <span >*</span>
                  </button>
                </td>
                <td class="memIdRow">
                  <span :style="{ left: item.depth * 20 + 'px' }">{{ item.memId }}</span>
                </td>
                <td>{{ item.memNick }}</td>
                <td>{{ item.belongCnt }}</td>
                <td>{{ item.cashAmt }}</td>
                <td>{{ item.pointAmt }}</td>
                <td>{{ item.cashInAmt }}</td>
                <td>{{ item.cashOutAmt }}</td>
              </tr>
            </tbody>
          </template>
          <template v-else>
            <tr>
              <td colspan="8">데이터가 없습니다.</td>
            </tr>
          </template>
        </table>
      </div>
    </div>
    <pagination v-if="tableData.length !== 0" @goPage="setTableData" :pageNum="pageInfo.page" :pageSize="pageInfo.count_per_list" :totalCount="pageInfo.tatal_list_count" />
  </section>
</template>

<script>
import lodash from "lodash";
import TableHead from "@/components/main/table/Head.vue";
import DateSelector from "@/components/common/DateSelector";
import { superRetail } from "@/api/company.js";
import { getCode } from "@/api/utils.js";
import { replceDateT, numberWithCommas, getDateStr } from "@/libs/utils.js";
import Pagination from "@/components/common/Pagination";
export default {
  name: "partnerList",
  components: {
    TableHead,
    Pagination,
    DateSelector
  },
  data: function () {
    return {
      modalOn: false,
      toggle: false,
      classes: {
        open: "fa-minus",
        close: "fa-plus"
      },
      headInfo: {
        fstColumn: true,
        dataList: ["id", "nick", "bottomuser", "cashAmt", "pointAmt", "depositm", "withdrawm"]
      },
      treeData: [],
      treeList: [],
      pageInfo: {
        page: 0,
        count_per_list: 0,
        tatal_list_count: 0
      },
      reqData: {
        page: 1,
        count_per_list: 30,
        siteId: "",
        searchType: "retail",
        memId: "",
        startDate: "",
        endDate: ""
      },
      dataKeys: ["memId", "memName", "belongCnt", "cashAmt", "pointAmt"],
      dateConfigs: {
        enableTime: false,
        dateFormat: "Y-m-d"
      },
      tableData: [],
      startDefault: "",
      endDefault: ""
    };
  },
  methods: {
    pageSeach(){
      if(this.reqData.siteId){
        this.setTableData(1);
      }else{
        alert('회사 아이디를 입력해주세요.')
      }
    },
    setStartDate(date) {
      // console.log(date);
      let _date = "";
      if (!date) {
        _date = new Date();
      } else {
        _date = date[0];
        _date.setHours(0, 0, 0);
      }
      this.startDefault = _date;
      this.reqData.startDate = getDateStr(_date, "yyyy-MM-dd HH:mm:ss");
    },
    setEndDate(date) {
      // console.log(date[0]);
      let _date = "";
      if (!date) {
        _date = new Date();
      } else {
        _date = date[0];
        _date.setHours(23, 59, 59);
      }
      this.endDefault = _date;
      this.reqData.endDate = getDateStr(_date, "yyyy-MM-dd HH:mm:ss");
    },
    async getTreeList(memId) {
      const req = lodash.cloneDeep(this.reqData);
      req.memId = memId;
      req.searchType = "tree";
      const res = await superRetail(req);
      return await res.data;
    },
    async setChildTree(parent, targetIdx) {
      parent.toggle = !parent.toggle;
      if (!parent.toggle) {
        this.delChildTree(parent, targetIdx+1);
        return;
      }
      const data = await this.getTreeList(parent.memId);
      const list = data.list;
      // console.log(list);
      // console.log(targetIdx);
      for (const item of list) {
        item.depth = parent.depth + 1;
        item.toggle = false;
        // console.log(item.depth);
        this.tableData.splice(targetIdx + 1, 0, item);
      }
    },
    delChildTree(parent, targetIdx) {
      const parentDepth = parent.depth;
      // console.log("---parentDepth");
      // console.log(parentDepth);
      console.log(`----targetIdx`)
      console.log(targetIdx);
      const delTargetIdx = targetIdx;
      let delCount = 0
      for (let i = delTargetIdx; i < this.tableData.length; i++) {
        const delItem = this.tableData[i];
        // console.log(`----itemInfo`)
        // console.log(delItem.memId);
        // console.log("---childDepth");
        // console.log(delItem.depth);
        if(!delItem.hasOwnProperty('depth')){
          break;
        }
        if (delItem.depth > parentDepth) {
          delCount++;
        } else {
          break;
        }
      }
      this.tableData.splice(delTargetIdx, delCount);
    },
    onClickTree(item, targetIdx) {
      const memId = item.memId;
      if (item.toggle) {
        this.delChildTree(memId, targetIdx);
      } else {
        this.setChildTree(memId, targetIdx);
      }
    },
    async getPartnerTopList(page) {
      const req = lodash.cloneDeep(this.reqData);
      if(page){
        req.page = page
      }
      const res = await superRetail(req);
      // console.log(res);
      return await res.data;
    },
    async setTableData(page) {
      const data = await this.getPartnerTopList(page);

      const memberList = data.list;
      for (const item of memberList) {
        for (const key in item) {
          const child = item[key];
          if (key.indexOf("Amt") > -1 || key.indexOf("Cnt") > -1) {
            item[key] = numberWithCommas(Number(child));
          }
          if (child === "") {
            item[key] = "-";
          }
        }
        item.depth = 0;
        item.toggle = false;
      }
      this.tableData = memberList;

      if (data.pageInfo) {
        this.pageInfo = data.pageInfo;
        this.pageInfo.tatal_list_count = numberWithCommas(this.pageInfo.tatal_list_count);
        this.pageInfo.tatal_page_count = numberWithCommas(Number(this.pageInfo.tatal_page_count) + 1);
      }
    }
  },
  async created() {
    this.setStartDate();
    this.setEndDate();
    this.setTableData();
  }
};
</script>

<style scoped>
.btn-stairOpen {
  display: flex;
  justify-content: center;
  align-items: center;
}
.buttonPositionWrap {
  display: flex;
  justify-content: center;
}
select {
  padding: 5px;
  font-size: 0.75em;
  border: 1px solid #737373;
  height: 26px;
}
.searchBar > * {
  margin-right: 5px;
}
.searchBar > *:last-child {
  margin-right: 0;
}
.memIdRow {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 350px;
}
.btn-childOpen {
  position: relative;
}
.memIdRow span {
  position: relative;
  white-space: nowrap;
}
</style>
